import React from "react";
import { Flag16Regular, Location16Regular, Mail16Regular, Phone16Regular } from "@fluentui/react-icons";
import InputReadOnlyField from "../form/field/read-only/Input";
import PhoneReadOnlyField from "../form/field/read-only/Phone";

const RelationInfo = ({ relation }) => {
  return (
    <>
      <InputReadOnlyField
        value={`
          ${relation.Addresses.main.address},
          ${relation.Addresses.main.postcode},
          ${relation.Addresses.main.city}
        `}
        icon={<Location16Regular />}
      />
      <PhoneReadOnlyField value={`${relation.phoneNumberMain}`} icon={<Phone16Regular />} />
      <InputReadOnlyField value={`${relation.email}`} icon={<Mail16Regular />} />
      <InputReadOnlyField value={`${relation.Addresses.main.country}`} icon={<Flag16Regular />} />
    </>
  );
};

export default RelationInfo;
